import { render, staticRenderFns } from "./RmrSelect.vue?vue&type=template&id=2ff63178&scoped=true&"
import script from "./RmrSelect.vue?vue&type=script&lang=js&"
export * from "./RmrSelect.vue?vue&type=script&lang=js&"
import style0 from "./RmrSelect.vue?vue&type=style&index=0&id=2ff63178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff63178",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
